// @flow
/**
 * requiredFeaturesAreSupported
 *
 * 動作に必要な機能がサポートされているかどうかを返す
 */
const requiredFeaturesAreSupported = (): boolean => {
  let result = false;

  // Check: FormData.entries()
  const formData = new FormData();
  if (
    window.FormData &&
    formData &&
    formData.entries &&
    typeof formData.entries === 'function'
  ) {
    result = true;
  }
  return result;
};

export default requiredFeaturesAreSupported;



// WEBPACK FOOTER //
// ./src/phase2/survey/app/requiredFeatures.js